<template>
  <div>
    <v-card v-if="Loading" color="yellow lighten-2">
      <v-card-text>
        <h3>Cargando</h3>
        <h3>Por Favor Espere...</h3>
      </v-card-text>
      <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <v-card :color="fondoEstado" v-if="!Loading">
      <v-app-bar color="cyan lighten-4" dense elevation="0">
        <v-toolbar-title>Nueva Practica </v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-row>
          <v-col md="12">
            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                <v-text-field
                  style="max-width: 220px;"
                  type="date"
                  dense
                  hide-details
                  outlined
                  label="Fecha de Prescripcion"
                  v-model="autorizacion.fechaprescripcion"
                  clearable
                >
                </v-text-field>
                <div v-if="!autorizacion.fechaprescripcion">
                  FECHA INVALIDA
                </div>
              </v-col>
            </v-card>
          </v-col>
          <v-col md="12" v-if="autorizacion.fechaprescripcion">
            <v-card class="my-1" elevation="4">
              <v-col class="teal lighten-4">
                Prestador
                <span class="pl-6" v-if="efector">
                  {{ efector.nombreefector }} ({{ efector.RAZON_SOCI }})
                  <v-btn icon>
                    <v-icon color="red" @click="efector = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </span>
              </v-col>
              <v-card-text v-if="!efector">
                <v-row no-gutters>
                  <v-col md="12">
                    <busquedaefector
                      :id_plan="id_plan"
                      v-model="efector"
                    ></busquedaefector>
                    <busquedaefectorProvincia
                      :id_plan="id_plan"
                      v-model="efector"
                    ></busquedaefectorProvincia>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col md="3" v-if="autorizacion.fechaprescripcion">
            <Imagenes :IdImagenes="autorizacion.idimagenes"></Imagenes>
            <v-btn @click="Guardar()" :disabled="listadocumentos.length === 0">
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const ID_EFECTOR = process.env.VUE_APP_EFECTOR_POR_DEFECTO;
import Imagenes from "@/components/Practica/Imagenes";
import busquedaefector from "@/components/Efectores/Autocomplete";
import busquedaefectorProvincia from "@/components/Efectores/PorProvincia";
import { mapActions, mapMutations, mapState } from "vuex";
import LUM from "@/lib/LUM";
import API from "@/lib/API";
export default {
  props: {
    id_afiliado: Number,
    id_plan: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Imagenes,
    busquedaefector,
    busquedaefectorProvincia,
  },
  data() {
    return {
      Loading: false,
      motivoEstado: "",
      diagnostico: undefined,
      practica: "",
      efector: undefined,
      prescriptor: undefined,
      efectorprofesional: undefined,
      autorizacion: {
        id_solic: 0,
        id_afiliado: 0,
        fechaprescripcion: "",
        fechaprogramada: "",
        idproblema: 0,
        problema: "",
        id_practica: 0,
        cantidad: 1,
        id_efector: ID_EFECTOR,
        id_efectorprofesional: 0,
        id_prescriptor: 0,
        tipo: 5,
        estado: 1,
        idimagenes: 0,
      },
    };
  },
  computed: {
    ...mapState("imagenespracticas", { listadocumentos: "Lista" }),
    estado() {
      let ret = "Sin Evaluar";
      switch (this.autorizacion.estado) {
        case 1:
          ret = "Pendiente";
          break;
        case 2:
          ret = "Autorizado";
          break;
        case 3:
          ret = "En Gestion";
          break;
        case 4:
          ret = "Rechazado";
          break;
        case 5:
          ret = "Cerrado";
          break;
        default:
          break;
      }
      return ret;
    },
    fondoEstado() {
      let ret = "lime lighten-4";
      switch (this.autorizacion.estado) {
        case 1:
          ret = "red";
          break;
        case 2:
          ret = "green";
          break;
        case 3:
          ret = "blue";
          break;
        case 4:
          ret = "black";
          break;
        case 5:
          ret = "white";
          break;
        default:
          break;
      }
      return ret;
    },
    hoy() {
      return LUM.datetoYYYYMMDD(new Date());
    },
    autorizacion_fechaprescripcion() {
      return this.autorizacion.fechaprescripcion;
    },
  },
  methods: {
    ...mapMutations("comun", ["mostrar"]),
    ...mapActions("autorizaciones", ["modificarEntidad"]),
    async Guardar() {
      this.Loading = true;
      await this.modificarEntidad(this.autorizacion);
      this.$emit("practicaGuardada");
      this.resetear();
      this.Loading = false;
    },
    resetear() {
      this.motivoEstado = "";
      this.diagnostico = undefined;
      this.practica = "";
      this.efector = undefined;
      this.prescriptor = undefined;
      this.efectorprofesional = undefined;
      this.autorizacion.id_solic = 0; //autorizacion= {
      //this.autorizacion.id_afiliado = 0;
      this.autorizacion.fechaprescripcion = "";
      this.autorizacion.fechaprogramada = "";
      this.autorizacion.idproblema = 0;
      this.autorizacion.problema = "";
      this.autorizacion.id_practica = 0;
      this.autorizacion.cantidad = 1;
      this.autorizacion.id_efector = ID_EFECTOR;
      this.autorizacion.id_efectorprofesional = 0;
      this.autorizacion.id_prescriptor = 0;
      this.autorizacion.tipo = 5;
      this.autorizacion.estado = 1;
      this.autorizacion.idimagenes = new Date().getTime();

      //};
    },
  },

  watch: {
    autorizacion_fechaprescripcion() {
      if (this.autorizacion_fechaprescripcion) {
        if (this.autorizacion_fechaprescripcion > this.hoy) {
          this.autorizacion.fechaprescripcion = "";
        }
      }
    },
    id_afiliado() {
      if (this.id_afiliado) {
        this.autorizacion.id_afiliado = this.id_afiliado;
      }
    },
    efector() {
      if (this.efector) {
        this.autorizacion.id_efector = this.efector.Id;
      } else {
        this.autorizacion.id_efector = ID_EFECTOR;
      }
    },
  },
  mounted() {
    //this.autorizacion.idimagenes = this.IdImagenes;
    this.autorizacion.idimagenes = new Date().getTime();
    this.autorizacion.id_afiliado = this.id_afiliado;
  },
};
</script>

<style></style>
